import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { PlaceSco, EScoActions, AddSco } from '../actions/sco.actions';
import { switchMap, concatMap, mergeMap } from 'rxjs/operators';
import { CartService } from 'src/app/service/cart/cart.service';
import { ISco } from 'src/app/models/sco.interface';
import { of } from 'rxjs';

@Injectable()
export class ScoEffects {
    
    placeSco$ = createEffect(() => this._action$.pipe(
        ofType<PlaceSco>(EScoActions.PlaceSco),
        mergeMap((action) => this._cartService.placeBetSingle(action.payload)),
        mergeMap((sco: ISco) => {
            return of(
                new AddSco(sco));
          })
    ));

    constructor(
        private _cartService: CartService,
        private _action$: Actions
    ) {}
}
